var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"}),_vm._v(" "),(_vm.productBrand === 'Poss')?_c('div',{staticClass:"col s12 z-depth-1 white logoBg"},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.productBrand === 'RailPredict')?_c('div',{staticClass:"col s12 z-depth-1 white logoRailPredictBg"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10bcd7fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reportItems/Page.vue
// module id = null
// module chunks = 